// extracted by mini-css-extract-plugin
export var component = "Card-module--component--2xHNi";
export var inner = "Card-module--inner--9leMN";
export var media = "Card-module--media--34lWt";
export var dummy = "Card-module--dummy--f3FNF";
export var content = "Card-module--content--0hcP4";
export var meta = "Card-module--meta--4FCJ5";
export var title = "Card-module--title--NpS6l";
export var badge = "Card-module--badge--f3U3-";